import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IStoreDesignation } from '../designations/designation';
import { MIHttpClientService } from 'src/app/shared/mi-http-client.service';
import { sortByField } from '../../shared/custom-rxjs-operators';


@Injectable({
  providedIn: 'root',
})
export class StoreDesignationService {

  constructor(private miClient: MIHttpClientService) { }

  getStoreDesignation(id: number): Observable<IStoreDesignation> {
    return this.miClient.get<IStoreDesignation>('storeDesignations/' + id);
  }

  getStoreDesignations(): Observable<IStoreDesignation[]> {
    return this.miClient.get<IStoreDesignation[]>('storeDesignations')
      .pipe(sortByField('storeDesignation'));
  }

  createStoreDesignation(item: IStoreDesignation): Observable<any> {
    delete item.id;
    return this.miClient.post('storeDesignations', item);
  }

  updateStoreDesignation(item: any): Observable<any> {
    return this.miClient.post('storeDesignations/' + item.id, item);
  }

  deleteStoreDesignation(id: number): Observable<any> {
    return this.miClient.delete('storeDesignations/' + id);
  }
}
